import styled$1 from 'styled-components';
import { space, colorSet } from '@ccg/core';
import '@4rk/modular-system';
import { getTypography } from '../../styles/typography.js';
import 'tinycolor2';
import React$1, { useRef, useState, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import { getTextColumns } from '../../basics/Text/helper/getGridColumns.js';
import { getGrid } from '../Grid/Grid.js';
import Text$1 from '../../basics/Text/Text.js';
import Button$1 from '../../basics/Button/Button.js';
import Cookies$1 from 'js-cookie';

const StyledSocialEmbed = styled$1.div`
  ${getGrid()}
  margin-top: ${space(6)};
  margin-bottom: ${space(6)};

  & > div {
    ${getTextColumns}
  }

  .socialEmbed__consent {
    padding: ${space(6)};
    background: ${colorSet('backgroundSecondary')};
    color: ${colorSet('colorSecondary')};
    text-align: center;
  }

  .socialEmbed__consent-text {
    margin-bottom: ${space(4)};

    p {
      ${getTypography.small};
      line-height: 2.2;
    }
  }
`;

const SocialEmbed = ({
  iframe,
  text,
  acceptLabel
}) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [event, setEvent] = useState(null);

  const handleClick = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const embed = ref.current;

    if (!isVisible) {
      if (window && window.instgrm) {
        window.instgrm.Embeds.process();
      }

      if (window && window.twttr && window.twttr.widgets) {
        window.twttr.widgets.load(embed);
      }
    }
  }, [isVisible]);
  useEffect(() => {
    const cookies = Cookies$1.get('acceptExternalContentCookies');
    setIsVisible(typeof cookies === 'undefined');
    setEvent(new Event('handleSocialEmbedClick'));
    window.addEventListener('handleSocialEmbedClick', handleClick);
    return () => window.removeEventListener('handleSocialEmbedClick', handleClick);
  }, []);

  const setCookie = value => {
    // also see Text component for custom optout/optin links
    Cookies$1.set('acceptExternalContentCookies', value, {
      expires: 14
    });
    window.dispatchEvent(event);
  };

  return /*#__PURE__*/React$1.createElement(StyledSocialEmbed, null, isVisible ? /*#__PURE__*/React$1.createElement("div", {
    className: "socialEmbed__consent"
  }, /*#__PURE__*/React$1.createElement(Text$1, {
    content: text,
    className: "socialEmbed__consent-text"
  }), /*#__PURE__*/React$1.createElement(Button$1, {
    className: "socialEmbed__consent-button",
    onClick: () => setCookie('accept'),
    icon: "tick"
  }, acceptLabel)) :
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React$1.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: iframe
    },
    ref: ref
  }));
};

SocialEmbed.propTypes = {
  iframe: PropTypes$1.string.isRequired,
  text: PropTypes$1.string.isRequired,
  acceptLabel: PropTypes$1.string.isRequired
};

export default SocialEmbed;
